export const truncate = (value: string, indexEnd: number, leader = '...') => {
  if (!value) return '';
  if (value.length <= indexEnd) return value;
  return `${value.substring(0, indexEnd)}${leader}`;
};

export function validatorInArray<T>(ary: Array<T>) {
  return function(value: T) {
    return ary.includes(value);
  };
}

export function pad(n: number, width: number, z = '0') {
  const _n = n + '';
  return _n.length > width ? _n : new Array(width - _n.length + 1).join(z) + _n;
}

export function stripWhiteSpace(content: string) {
  return content ? `${content}`.replace(/\s+|\s/gm, '') : '';
}

export function stripNewLine(content: string) {
  return content ? `${content}`.replace(/\t|\r\n|\n|\r/gim, '') : '';
}
